import React from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { Box, Button, IconButton, styled, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowLeft from "@icons/myicons/arrow-left.svg?react";
import ManuellImage from "@images/add/Manuell.svg?react";
import { Modal } from "@rentablo/components";

const ImageBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%",
  margin: theme.spacing(10, 0, 8),

  "& .bank-background": {
    fill: theme.palette.background.info,
  },

  "& .bank-icon-background": {
    fill: theme.palette.primary.dark,
  },

  "& .bank-lock": {
    fill: theme.palette.primary.main,
  },

  "& .bank-link": {
    fill: theme.palette.primary.light,
  },

  "& .bank-link-manual": {
    stroke: theme.palette.primary.light,
  },

  "& .bank-success": {
    fill: theme.palette.success.main,
  },

  "& .bank-list-header": {
    fill: theme.palette.primary.main,
  },

  "& .paper-background": {
    fill: theme.palette.primary.lighter,
  },

  "& .paper-corner": {
    fill: theme.palette.primary.light,
  },

  "& .pdf-background": {
    fill: theme.palette.warning.main,
  },
}));

interface Props {
  open: boolean;
  onClose: () => void;
  type: string;
}

export const NoQuoteModal = ({ open, onClose, type }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const openManualWizard = () => {
    navigate(`/manual-transaction-wizard?type=${type}`);
  };

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      contentPadding="30px"
      title={
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gap={4}
        >
          <IconButton
            color="tertiary"
            onClick={onClose}
            data-testid="back-button"
            size="small"
            sx={{
              width: "44px",
              height: "44px",
            }}
          >
            <ArrowLeft width="24px" height="24px" />
          </IconButton>
          <Box width="100%">
            <Box>
              <Typography variant="h4" fontWeight={600}>
                {t("transactionWizard.searchSymbolsStep.noQuoteModal.title")}
              </Typography>
            </Box>
          </Box>
          <IconButton
            onClick={onClose}
            size="small"
            data-testid="close-login-hint-button"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      }
    >
      <Box>
        <ImageBox>
          <Box borderRadius={1} overflow="hidden" display="inline-block">
            <ManuellImage />
          </Box>
        </ImageBox>
        <Typography variant="body1" mb={10}>
          {t("transactionWizard.searchSymbolsStep.noQuoteModal.text")}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={openManualWizard}
          fullWidth
        >
          {t("transactionWizard.searchSymbolsStep.noQuoteModal.confirm")}
        </Button>
      </Box>
    </Modal>
  );
};
